// extracted by mini-css-extract-plugin
export default {"container":"styles__container___f1hFw","cancelButtonContainer":"styles__cancelButtonContainer___wLpkc"};